import { rem } from "@/styles/utils"
import { device_px } from "@/styles/variable"
import styled from "styled-components"

const { MAX_767 } = device_px

export const NoSessionDataContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: ${MAX_767}) {
    height: ${rem(433 - 77)};
  }
`
export const NoSessionDataText = styled.p`
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 22.4px */
`
